// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLER_ADD_WISHLIST = "Ulo\u017e si ko\u010d\u00edk";
